import { useMemo } from "react";

export function useComputeRecommendedPowerAssetsTotal(recommendedPowerAssets) {
  return useMemo(() => {
    return recommendedPowerAssets.reduce(
      (
        [totalCapacity, totalTraded, totalExpectedNewPowerRevenues, totalInvestment],
        powerAsset
      ) => {
        return [
          totalCapacity + powerAsset.production,
          totalTraded + powerAsset.acc_revenue,
          totalExpectedNewPowerRevenues + powerAsset.expected_power_revenue,
          totalInvestment,
        ];
      },
      [0, 0, 0, 0]
    );
  }, [recommendedPowerAssets.length]);
}
